export const FETCH_PRODUCT_CATEGORY = 'FETCH_PRODUCT_CATEGORY';
export const FILTER_PRODUCT_CATEGORY = 'FILTER_PRODUCT_CATEGORY';